module.exports = __webpack_public_path__ + "static/img/nav_bg.12896229.png";